import { Box } from "@mui/material";
import styled from "@emotion/styled";

export const BreadcrumbBar = styled(Box)`
display:flex;
align-items:center;
justify-content:space-between;
`

// sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}